module.exports = __webpack_public_path__ + "static/img/医生发布@3x.a7f264c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/bottom/医生发布@3x.png
// module id = 1237
// module chunks = 358